/**
 * Uebersicht-Mode-Marker via sessionStorage.
 *
 * Wird gesetzt, sobald der User die OverviewTabBar betritt (`/uebersicht/*`).
 * Bleibt aktiv, wenn er von dort in eine Detail-Seite eines Moduls navigiert
 * (`/m/<modul>/...`) — dann blendet ModuleLayout seine Sidebar/BottomNav aus
 * und die OverviewTabBar bleibt als einzige Navigation sichtbar.
 *
 * Wird zurueckgesetzt, sobald der User den Modul-Picker (HomePage `/`) oeffnet.
 */
const KEY = 'overview-mode';

export function setOverviewMode(active: boolean): void {
  if (typeof sessionStorage === 'undefined') return;
  if (active) sessionStorage.setItem(KEY, '1');
  else sessionStorage.removeItem(KEY);
}

export function isOverviewMode(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(KEY) === '1';
}
